import { EXERCISES_UI_FILTERS_KEY, EXERCISES_UI_KEY } from './key'

const EXERCISES_UI_STATE = {
  [EXERCISES_UI_KEY.TYPE_FILTER]: [],
  [EXERCISES_UI_KEY.MUSCLE_FILTER]: [],
  [EXERCISES_UI_KEY.EQUIPMENT_FILTER]: [],
  [EXERCISES_UI_KEY.FILTERS]: {
    [EXERCISES_UI_FILTERS_KEY.TYPES]: [],
    [EXERCISES_UI_FILTERS_KEY.MUSCLES]: [],
    [EXERCISES_UI_FILTERS_KEY.EQUIPMENT]: []
  },
  [EXERCISES_UI_KEY.QUERY]: '',
  [EXERCISES_UI_KEY.PAGE]: 1
}

export default EXERCISES_UI_STATE
